import { initMessaging, getToken } from '../services/firebase-config.ts';

export const permissionStates = {
	granted: 'granted',
	denied: 'denied',
	prompt: 'prompt',
	unavailable: 'unavailable',
	unknown: 'unknown',
	error: 'error'
} as const;

type PermissionState = keyof typeof permissionStates;

export const permissionStateMessages: Record<PermissionState, string> = {
	granted: 'İzin verildi ✅',
	denied: 'İzin reddedildi ❌',
	prompt: 'Sorulacak (henüz sorulmadı)',
	unavailable: 'Cihaz mevcut değil',
	unknown: 'Bilinmiyor ❔',
	error: 'Hata ❗'
};

export const requestCameraAndMicPermission = async (): Promise<boolean> => {
	try {
		const stream = await navigator.mediaDevices.getUserMedia({
			video: true,
			audio: true
		});
		return !!stream;
	} catch (error) {
		console.error('Kamera ve mikrofon izni alınamadı:', error instanceof Error ? error.message : error);
		return false;
	}
};

type PermissionStatusResult = {
	camera?: PermissionState;
	microphone?: PermissionState;
} | null;

export const checkPermissionStatus = async (): Promise<PermissionStatusResult> => {
	if (navigator?.permissions && navigator?.permissions?.query) {
		try {
			const cameraPermission = await navigator.permissions.query({
				name: 'camera' as PermissionName
			});

			const microphonePermission = await navigator.permissions.query({
				name: 'microphone' as PermissionName
			});

			return {
				camera: cameraPermission.state as PermissionState,
				microphone: microphonePermission.state as PermissionState
			};
		} catch (error) {
			console.error('İzin durumu kontrolü başarısız:', error);
			return null;
		}
	} else {
		console.warn("Bu tarayıcı Permissions API'yi desteklemiyor.");
		return null;
	}
};

export const requestNotificationPermission = async (): Promise<boolean> => {
	try {
		const permission = await Notification.requestPermission();
		if (permission !== 'granted') {
			console.warn('Bildirim izni reddedildi.');
			return false;
		}

		const registration = await navigator.serviceWorker.register('/firebase-messaging-sw.js');

		const { messaging, supported } = await initMessaging();

		if (!supported || !messaging) {
			console.warn('Tarayıcı FCM desteklemiyor.');
			return false;
		}

		await getToken(messaging, {
			vapidKey: process.env.FCM_KEY,
			serviceWorkerRegistration: registration
		});

		return true;
	} catch (error) {
		console.error('🔴 Bildirim izni alınırken hata:', error);
		return false;
	}
};
export const checkNotificationPermissionStatus = (): PermissionState => {
	const state = Notification.permission;
	if (state === 'granted') return 'granted';
	if (state === 'denied') return 'denied';
	if (state === 'default') return 'prompt';
	return 'unknown';
};
